import { useEffect, useState, useMemo } from "react";
import ApplicationOverview from "./ApplicationOverview";
import ApplicationTable from "./ApplicationTable";
import { applicationServiceAPI } from "../../http/http";
import { toast } from "react-toastify";

interface Application {
  applicationId: string;
  schoolName: string;
  currentState: string;
  createdAt: string;
  formId: string;
  type: string;
  updatedAt: string;
  userId: string;
}

interface Metrics {
  total: number;
  approved: number;
  rejected: number;
}

const ApplicationPage = () => {
  const [isLoadingMetrics, setIsLoadingMetrics] = useState(false);
  const [isLoadingApplications, setIsLoadingApplications] = useState(false);
  const [applications, setApplications] = useState<Application[]>([]);
  const [metrics, setMetrics] = useState<Metrics | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMetrics = async () => {
      setIsLoadingMetrics(true);
      try {
        const response = await applicationServiceAPI.get('/user/metrics');
        setMetrics(response.data.data.metrics);
      } catch (err: any) {
        console.error(err);
        toast.error(err.message ?? 'Failed to load metrics');
        setError('Failed to load metrics.');
      } finally {
        setIsLoadingMetrics(false);
      }
    };

    const fetchApplications = async () => {
      setIsLoadingApplications(true);
      try {
        const response = await applicationServiceAPI.get('/applications');
        setApplications(response.data.data.applications);
      } catch (err: any) {
        console.error(err);
        toast.error(err.message ?? 'Failed to load applications');
        setError('Failed to load applications.');
      } finally {
        setIsLoadingApplications(false);
      }
    };

    // Fetch metrics and applications concurrently
    fetchMetrics();
    fetchApplications();
  }, []);

  const columns = useMemo(
    () => [
      { name: "School Name", accessor: "schoolName" },
      { name: "Type", accessor: "type" },
      { name: "Status", accessor: "currentState" },
      { name: "Date Created", accessor: "createdAt" },
    ],
    []
  );

  return (
    <div className="">
      {isLoadingMetrics ? (
        <div>Loading metrics...</div>
      ) : metrics ? (
        <ApplicationOverview metrics={metrics} />
      ) : (
        error && <div>{error}</div>
      )}

      {isLoadingApplications ? (
        <div>Loading applications...</div>
      ) : (
        <ApplicationTable
          tableData={{
            columns,
            data: { applications },
          }}
        />
      )}
    </div>
  );
};

export default ApplicationPage;
